import { translate, TranslatorKeys } from "@/config/translator";
import { PasswordRequirementItem } from "../passwordRequirementItem/passwordRequirementItem";
import { useContext } from "react";
import { PspContext } from "@/config/contexts";
import { PasswordPolicyError } from "@/config/types";

type PasswordRequirementsListProps = {
  passwordsDontMatch: boolean;
  passwordRequirements: Record<PasswordPolicyError, boolean>;
};

export function PasswordRequirementsList({
  passwordsDontMatch,
  passwordRequirements,
}: PasswordRequirementsListProps) {
  const { lang } = useContext(PspContext);

  return (
    <div className="flex flex-col gap-2">
      <PasswordRequirementItem isSatisfied={!passwordsDontMatch}>
        {translate("passwordsMatch", lang)}
      </PasswordRequirementItem>
      {Object.entries(passwordRequirements).map(([policyError, error]) => (
        <PasswordRequirementItem isSatisfied={!error}>
          {translate(("password_" + policyError) as TranslatorKeys, lang)}
        </PasswordRequirementItem>
      ))}
    </div>
  );
}
